import {useEntityAccessControlStore} from "@/stores/entityAccessControl";
import { onMounted, ref } from 'vue'

export function useAccessControlUtils() {

    const accessControlStore = useEntityAccessControlStore();

    const isAccessControlLoading = ref(false);

    const onApplicationsSelected = async (apps: string[]) => {
        try {
            for (const app of apps) {
                await accessControlStore.fetchRoleOptions(app)
            }
        } catch (error) {
            console.error('Error loading application data:', error)
        } finally {}
    }

    const onFetchPrincipalValues = async (app: string, type: any) => {
        try {
            await accessControlStore.fetchPrincipalValues(app, type)
        } catch (error) {
            console.error('Error fetching principal values:', error)
        }
    }


    onMounted(async () => {
        await accessControlStore.fetchApps();
    })

    return {
        onApplicationsSelected,
        onFetchPrincipalValues,
        accessControlStore,
        isAccessControlLoading,
    }

}